import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom'

//--- Estilos e íconos de Bootstrap ---//
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import './css/styles.min.css'
//--- Estilos e íconos de Bootstrap ---//

// import { Login } from './components/Login/Login'
// import { SecondaryLogin } from './components/Login/SecondaryLogin'
import { Dashboard } from './components/Dashboard/Dashboard'
import { Games } from './components/Games/Games'
import { Lobby } from './components/Lobby/Lobby'
import { NotFound } from './components/Commons/NotFound'
import { GoalFan } from './components/Dashboard/Sections/Goal'
import { SelfieFan } from './components/Dashboard/Sections/SelfieFan'
import { CarreraContinuaFan } from './components/Dashboard/Sections/CarreraContinuaFan'
import { Messages } from './components/Dashboard/Sections/Messages'
import { NoisemeterV2 } from './components/Dashboard/Sections/NoisemeterV2'
import { PersonalNoisemeter } from './components/Dashboard/Sections/PersonalNoisemeter'
import { PersonalRouletteFan } from './components/Dashboard/Sections/PersonalRouletteFan'
import { FightersFan } from './components/Dashboard/Sections/FightersFan'
import { QuickReactionFan } from './components/Dashboard/Sections/QuickReactionFan'
import { PersonalQuickReactionFan } from './components/Dashboard/Sections/PersonalQuickReactionFan'
import { PersonalSurferFan } from './components/Dashboard/Sections/PersonalSurferFan'
import { PlaylistFan } from './components/Dashboard/Sections/PlaylistFan'
import { SequenceFan } from './components/Dashboard/Sections/SequenceFan'
import { MemoryPlayer } from './components/Dashboard/Sections/MemoryPlayer'
import { TugOfWarFan } from './components/Dashboard/Sections/TugOfWarFan'
import { SurferFan } from './components/Dashboard/Sections/SurferFan'

import { Recolector } from './components/Dashboard/Sections/Recolector'
import { PluckingRooster } from './components/Dashboard/Sections/PluckingRooster'
import { ResetPluckingRooster } from './components/Dashboard/Sections/ResetPluckingRooster'
import { Picnic } from './components/Dashboard/Sections/Picnic'
import { Briefcase } from './components/Dashboard/Sections/Briefcase'
import { Tacos } from './components/Dashboard/Sections/Tacos'
import { CatchTheBall } from './components/Dashboard/Sections/CatchTheBall'
import { SlotMachine } from './components/Dashboard/Sections/SlotMachine'
import { Caps } from './components/Dashboard/Sections/Caps'
import { Roulette } from './components/Dashboard/Sections/Roulette'
import { RubaQuizFan } from './components/Dashboard/Sections/RubaQuizFan'
import { MvpXolosZoneFan } from './components/Dashboard/Sections/MvpXolosZoneFan'
import { XtpFan } from './components/Dashboard/Sections/XtpFan'
import { XtpPassFan } from './components/Dashboard/Sections/XtpPassFan'
import { XoloFestLanding } from './components/XoloFest/XoloFestLanding'
import { XoloFestPassport } from './components/XoloFest/XoloFestPassport'
import { XoloFestScanner } from './components/XoloFest/XoloFestScanner'
import { XoloFestBoard } from './components/XoloFest/XoloFestBoard'
import { BongoMobile } from './components/Dashboard/Sections/BongoMobile'
import { CookieBanner } from './components/Commons/CookieBanner'


//--- Admin ---//
import { Login } from './components/Admin/Login/Login'
import { Dashboard as AdmDashboard } from './components/Admin/Dashboard/Dashboard'
import { Colors } from './components/Admin/Games/Colors'
import { Quiz } from './components/Admin/Games/Quiz'
import { Lottery } from './components/Admin/Games/Lottery'
import { FanCamIA } from './components/Admin/FanCam/FanCamIA'
import { SelfieFan as SelfieFanAdmin } from './components/Admin/FanCam/SelfieFan'
import { LyricsGenerator } from './components/Admin/Games/Karaoke/LyricsGenerator'
import { MessagesBoard } from './components/Admin/Overlays/Messages/MessagesBoard'
import { RubaQuizBoard } from './components/Admin/Overlays/RubaQuiz/RubaQuizBoard'
import { SelfieFanLibrary } from './components/Admin/Games/SelfieFanPlayer/SelfieFanLibrary'
import EventsManager from './components/Admin/Events/EventsManager'
import ZoneListsManager from './components/Admin/Events/ZoneListsManager'
import TriviaManager from './components/Admin/Events/TriviaManager'
import RiddleManager from './components/Admin/Events/RiddleManager'
import RoomControlPanel from './components/Admin/Dashboard/RoomControlPanel'
import { OperatorsManager } from './components/Admin/Operators/OperatorsManager'
import { AuthProvider } from './components/Providers/AuthProvider'
import { ProtectedRoute } from './components/Commons/ProtectedRoute'
import { Login as LoginV2 } from './components/Login/Login'
import { Tombola as TombolaAdmin } from './components/Admin/Overlays/Tombola'
import { Soccer as SoccerAdmin } from './components/Admin/Overlays/Soccer'
import { PlaylistSpecialBoard } from './components/Admin/Overlays/Playlist/PlaylistSpecialBoard'
import { QuickReactionPersonalBoard } from './components/Admin/Overlays/QuickReactionPersonal/QuickReactionPersonalBoard'
import { Sequence as SequenceAdmin } from './components/Admin/Games/Sequence'
// import TeamsManager from './components/Admin/Sports/TeamsManager'

// import PlayersManager from './components/Admin/Sports/PlayersManager'
//--- Admin ---//

//--- Screen ---//
import { Screen } from './components/Screen/Screen'
import { ScreenV2 } from './components/Screen/ScreenV2'
import { Karaoke } from './components/Overlays/Karaoke'
import { Messages as MessagesOverlay } from './components/Overlays/Messages'
import { PluckingRooster as PluckingRoosterOverlay } from './components/Overlays/PluckingRooster'
import { SelfieFan as SelfieFanOverlay } from './components/Overlays/SelfieFan'
import { KaraokeCam as KaraokeCamOverlay } from './components/Overlays/KaraokeCam'
import { InteractiveChat as InteractiveChatOverlay } from './components/Overlays/InteractiveChat'
import { RubaQuiz as RubaQuizOverlay } from './components/Overlays/RubaQuiz'
import { SlotMachine as SlotMachineScreen } from './components/Screen/Sections/SlotMachine'
import { Tombola as TombolaOverlay } from './components/Overlays/Tombola'
import { Soccer as SoccerOverlay } from './components/Overlays/Soccer'
import { Dance as DanceOverlay } from './components/Overlays/Dance'
import { Bongo as BongoOverlay } from './components/Overlays/Bongo'
import { Kiss as KissOverlay } from './components/Overlays/Kiss'
import { PersonalNoisemeterRanking } from './components/Overlays/PersonalNoisemeterRanking'
import { Playlist as PlaylistOverlay } from './components/Overlays/Playlist'
import PersonalQuickReactionOverlay from './components/Overlays/PersonalQuickReactionOverlay'
import { MvpXolosZone as MvpXolosZoneOverlay } from './components/Overlays/MvpXolosZone'
import PersonalSurferOverlay from './components/Overlays/PersonalSurferOverlay'
//import { Noisemeter as NoisemeterOverlay } from './components/Overlays/Noisemeter'
//--- Screen ---//

//--- Test ---//
import { Cuadricula } from './components/Test/Cuadricula'
import { Textos } from './components/Test/Textos'
import { Imagenes } from './components/Test/Imagenes'
//--- Test ---//


import { SignalRTest } from './components/SignalRTest'


//--- Ztudia ---//
import { ZtudiaAuthInterceptor } from './components/Ztudia/ZtudiaAuthInterceptor';
import { ZtudiaLobby } from './components/Ztudia/ZtudiaLobby';
import { Goal as ZtudiaGoal } from './components/Ztudia/Games/Goal'
import RoomLoader from './components/SaaS/RoomLoader';


const StandScreenWrapper = () => {
    let { id } = useParams();
    // Le pasamos el ID a la máquina para que se conecte al WebSocket privado (ej. "slotmachine:screen:1")
    return <SlotMachineScreen screenId={id} />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <CookieBanner />
        <Routes>
          <Route
            path='/login'
            element={<LoginV2 />}
          />

          <Route
            path='/'
            element={<RoomLoader><Dashboard /></RoomLoader>}
          />

          {/* <Route
            path='/fan'
            element={<RoomLoader><Dashboard /></RoomLoader>}
          /> */}
          
          {/*<Route
            path="/xyz/games/gol" //"/gol"
            element={<GoalFan />}
          />*/}

          <Route
            path="/gol"
            element={<RoomLoader><GoalFan /></RoomLoader>}
          />

          <Route
            path="/carreracontinua"
            element={<RoomLoader><CarreraContinuaFan /></RoomLoader>}
          />

          <Route
            path="/selfiefan"
            element={<RoomLoader><SelfieFan /></RoomLoader>}
          />

          <Route
            path="/messages"
            element={<Messages />}
          />

          <Route
            path="/playlist"
            element={<RoomLoader><PlaylistFan /></RoomLoader>}
          />

          <Route
            path="/rubaquiz"
            element={<RubaQuizFan />}
          />

          {/* ===== Convivencia en la zona (Xolos Femenil MVP Zone) ===== */}
          <Route
            path="/xolos-mvp-zone"
            element={<MvpXolosZoneFan />}
          />

          {/* ===== Medallas Tradiciones Perronas 2026 (XTP - Tile 52) ===== */}
          <Route
            path="/tpx2026"
            element={<XtpFan />}
          />
          <Route
            path="/passtpx"
            element={<XtpPassFan />}
          />

          {/* ===== Xolo Fest 2026: Pasaporte Digital, Zonas y Tómbola Perrona (Tile 53) ===== */}
          <Route
            path="/demo/xolofest"
            element={<XoloFestLanding />}
          />
          <Route
            path="/demo/xolofest/scanner"
            element={<XoloFestScanner />}
          />
          <Route
            path="/demo/xolofest/board"
            element={<XoloFestBoard />}
          />
          <Route
            path="/demo/xolofest/passport"
            element={<XoloFestPassport />}
          />

          {/* ===== Grito Mexicano (PersonalNoisemeter / Noisemeter) ===== */}
          <Route
            path="/noisemeter"
            element={<RoomLoader><PersonalNoisemeter /></RoomLoader>}
          />

          <Route
            path="/noisemeter/ranking"
            element={<RoomLoader><PersonalNoisemeterRanking /></RoomLoader>}
          />

          <Route
            path="/abcdef/games/recolector"
            element={<Recolector />}
          />

          <Route
            path="/rooster" ///abcdef/games/rooster
            element={<PluckingRooster />}
          />

          <Route
            path="/xyz/reset/rooster" ///abcdef/games/rooster
            element={<ResetPluckingRooster />}
          />

          <Route
            path="/picnic"
            element={<RoomLoader><Picnic /></RoomLoader>}
          />

          <Route
            path="/briefcase"
            element={<RoomLoader><Briefcase /></RoomLoader>}
          />

          <Route
            path="/tacos"
            element={<RoomLoader><Tacos /></RoomLoader>}
          />

          <Route
            path="/gamepad"
            element={<RoomLoader><CatchTheBall /></RoomLoader>}
          />

          <Route
            path="/slot"
            element={<RoomLoader><SlotMachine /></RoomLoader>}
          />

          <Route
            path="/bongo"
            element={<RoomLoader><BongoMobile /></RoomLoader>}
          />
          
          <Route
            path="/pantalla-stand/:id"
            element={<StandScreenWrapper />}
          />

          <Route
            path="/caps"
            element={<RoomLoader><Caps /></RoomLoader>}
          />

          <Route
            path="/roulette"
            element={<RoomLoader><Roulette /></RoomLoader>}
          />

          {/* ===== Ruleta Baja Cup (Personal Roulette) ===== */}
          <Route
            path="/psl-roulette"
            element={<RoomLoader><PersonalRouletteFan /></RoomLoader>}
          />

          {/* ===== Batalla de Luchadores (Fighters Mobile Fan) ===== */}
          <Route
            path="/fighters"
            element={<RoomLoader><FightersFan /></RoomLoader>}
          />

          {/* ===== Reacción Rápida 1 vs 1 (Quick Reaction Mobile Fan) ===== */}
          <Route
            path="/quick-reaction"
            element={<RoomLoader><QuickReactionFan /></RoomLoader>}
          />

          {/* ===== Reacción Rápida Personal (Personal Quick Reaction Fan) ===== */}
          <Route
            path="/psl-qreaction"
            element={<RoomLoader><PersonalQuickReactionFan /></RoomLoader>}
          />

          {/* ===== Esquivador Personal (Personal Surfer Mobile Fan) ===== */}
          <Route
            path="/psl-surfer"
            element={<RoomLoader><PersonalSurferFan /></RoomLoader>}
          />

          {/* <Route
            path="/personal-surfer"
            element={<RoomLoader><PersonalSurferFan /></RoomLoader>}
          />
          <Route
            path="/personalsurfer"
            element={<RoomLoader><PersonalSurferFan /></RoomLoader>}
          /> */}

          {/* ===== Secuencia (Simon Says Mobile Fan) ===== */}
          <Route
            path="/sequence"
            element={<RoomLoader><SequenceFan /></RoomLoader>}
          />

          {/* ===== Memorama 1 vs 1 (Memory Mobile Fan) ===== */}
          <Route
            path="/memory"
            element={<RoomLoader><MemoryPlayer /></RoomLoader>}
          />

          {/* ===== Estira y Afloja (Tug of War Mobile Fan) ===== */}
          <Route
            path="/tugofwar"
            element={<RoomLoader><TugOfWarFan /></RoomLoader>}
          />

          {/* ===== Esquivador (Surfer Mobile Fan) ===== */}
          {/* <Route
            path="/surfer-fan"
            element={<RoomLoader><SurferFan /></RoomLoader>}
          /> */}
          <Route
            path="/surfer"
            element={<RoomLoader><SurferFan /></RoomLoader>}
          />

          {/* <Route
            path='/lobby'
            element={<Lobby />}
          /> */}

          {/* <Route
            path='/games'
            element={<Games />}
          /> */}





          {/* Panel de administración */}
          {/* <Route
            path='/admin'
            element={<LoginV2 />}
          /> */}

          <Route
            path='/admin/dashboard'
            element={<ProtectedRoute><AdmDashboard /></ProtectedRoute>}
          />

          <Route
            path='/admin/rooms-control'
            element={<ProtectedRoute><RoomControlPanel /></ProtectedRoute>}
          />

          <Route
            path='/admin/colors'
            element={<ProtectedRoute><Colors /></ProtectedRoute>}
          />

          <Route
            path='/admin/quiz'
            element={<ProtectedRoute><Quiz /></ProtectedRoute>}
          />

          <Route
            path='/admin/rubaquiz'
            element={<ProtectedRoute><RubaQuizBoard /></ProtectedRoute>}
          />

          <Route
            path='/admin/lottery'
            element={<ProtectedRoute><Lottery /></ProtectedRoute>}
          />

          <Route
            path='/admin/ia'
            element={<ProtectedRoute><FanCamIA /></ProtectedRoute>}
          />

          <Route
            path='/admin/selfiefan'
            element={<ProtectedRoute><SelfieFanAdmin /></ProtectedRoute>}
          />

          <Route
            path='/admin/karaoke/create'
            element={<ProtectedRoute><LyricsGenerator /></ProtectedRoute>}
          />

          <Route
            path='/xyz/messages/board' //'/admin/messages/board'
            element={<ProtectedRoute><MessagesBoard /></ProtectedRoute>}
          />

          <Route
            path='/admin/library/'
            element={<ProtectedRoute><SelfieFanLibrary /></ProtectedRoute>}
          />

          <Route
            path='/admin/events-v2'
            element={<ProtectedRoute allowedRoles={['BusinessAdmin', 'SuperAdmin']}><EventsManager getOutOfTheDynamic={() => window.location.href = '/admin/dashboard'} /></ProtectedRoute>}
          />

          <Route
            path='/admin/zones-lists'
            element={<ProtectedRoute allowedRoles={['BusinessAdmin', 'SuperAdmin']}><ZoneListsManager getOutOfTheDynamic={() => window.location.href = '/admin/events-v2'} /></ProtectedRoute>}
          />

          <Route
            path='/admin/trivias'
            element={<ProtectedRoute allowedRoles={['BusinessAdmin', 'SuperAdmin']}><TriviaManager getOutOfTheDynamic={() => window.location.href = '/admin/events-v2'} /></ProtectedRoute>}
          />

          <Route
            path='/admin/riddles'
            element={<ProtectedRoute allowedRoles={['BusinessAdmin', 'SuperAdmin']}><RiddleManager getOutOfTheDynamic={() => window.location.href = '/admin/events-v2'} /></ProtectedRoute>}
          />

          <Route
            path='/admin/riddle-manager'
            element={<ProtectedRoute allowedRoles={['BusinessAdmin', 'SuperAdmin']}><RiddleManager getOutOfTheDynamic={() => window.location.href = '/admin/events-v2'} /></ProtectedRoute>}
          />

          <Route
            path='/admin/operators'
            element={<ProtectedRoute><OperatorsManager /></ProtectedRoute>}
          />

          <Route
            path='/admin/tombola'
            element={<ProtectedRoute><TombolaAdmin /></ProtectedRoute>}
          />

          <Route
            path='/admin/soccer'
            element={<ProtectedRoute><SoccerAdmin /></ProtectedRoute>}
          />

          <Route
            path='/admin/playlist/cabina'
            element={<ProtectedRoute><PlaylistSpecialBoard /></ProtectedRoute>}
          />

          <Route
            path='/admin/sequence'
            element={<ProtectedRoute><SequenceAdmin /></ProtectedRoute>}
          />

          {/* <Route
            path='/admin/quick-reaction-personal'
            element={<ProtectedRoute><QuickReactionPersonalBoard getOutOfTheDynamic={() => window.location.href = '/admin/dashboard'} /></ProtectedRoute>}
          /> */}






          {/* Página Screen */}
          <Route
            path='/screen'
            element={<RoomLoader><Screen /></RoomLoader>}
          />

          <Route
            path='/screen-v2'
            element={<RoomLoader><ScreenV2 /></RoomLoader>}
          />

          {/* Rutas directas para Pantallas de Estadio: Esquivador (Surfer) */}
          <Route
            path='/surfer-cover'
            element={<Screen defaultView="surfer_cover" />}
          />
          <Route
            path='/surfer-game'
            element={<Screen defaultView="surfer_game" />}
          />
          <Route
            path='/surfer-screen'
            element={<Screen defaultView="surfer_game" />}
          />


          {/* ===== Overlays ===== */}
          {/* Página Overlay Karaoke */}
          <Route
            path='/abcdef/overlays/karaoke/'
            element={<Karaoke />}
          />

          <Route
            path='/abcdef/overlays/messages/'
            element={<MessagesOverlay />}
          />

          <Route
            path='/abcdef/overlays/rubaquiz/'
            element={<RubaQuizOverlay />}
          />

          <Route
            path='/abcdef/overlays/rooster/'
            element={<PluckingRoosterOverlay />}
          />

          <Route
            path='/abcdef/overlays/selfiefan/'
            element={<SelfieFanOverlay />}
          />

          <Route
            path='/abcdef/overlays/karaokecam/'
            element={<KaraokeCamOverlay />}
          />

          <Route
            path='/abcdef/overlays/chat/'
            element={<InteractiveChatOverlay />}
          />

          <Route
            path='/abcdef/overlays/tombola/'
            element={<TombolaOverlay />}
          />

          <Route
            path='/abcdef/overlays/soccer'
            element={<SoccerOverlay />}
          />

          <Route
            path='/abcdef/overlays/dance'
            element={<DanceOverlay />}
          />

          <Route
            path='/abcdef/overlays/bongo'
            element={<BongoOverlay />}
          />

          <Route
            path='/abcdef/overlays/kiss'
            element={<KissOverlay />}
          />

          <Route
            path='/abcdef/overlays/playlist'
            element={<PlaylistOverlay />}
          />

          <Route
            path='/abcdef/overlays/quick-reaction'
            element={<PersonalQuickReactionOverlay />}
          />

          <Route
            path='/abcdef/overlays/xolosmvpzone'
            element={<MvpXolosZoneOverlay />}
          />

          {/* <Route
            path='/abcdef/overlays/quizzb9zone'
            element={<MvpXolosZoneOverlay />}
          /> */}

          <Route
            path='/abcdef/overlays/psl-surfer'
            element={<PersonalSurferOverlay />}
          />

          {/* <Route
            path='/abcdef/overlays/noisemeter/'
            element={<NoisemeterOverlay />}
          /> */}





          {/* Página 404 */}
          <Route
            path='*'
            element={<NotFound />}
          />




          {/* Ztudia */}
          {/* RUTA 1: El interceptor de entrada. Atrapa el ?shp= */}
          <Route
            path='/ztudia/'
            element={<ZtudiaAuthInterceptor />}
          />

          {/* RUTA 2: El menú principal donde eligen el juego */}
          <Route
            path='/ztudia/lobby'
            element={<ZtudiaLobby />}
          />

          {/* RUTA 3: Los Juegos */}
          <Route
            path='/ztudia/gol'
            element={<ZtudiaGoal />}
          />

          {/* <Route
            path='/ztudia/caps'
            element={<Caps />}
          /> */}




          {/* Páginas de prueba */}
          {/* <Route
            path='/cuadricula'
            element={<Cuadricula />}
          />

          <Route
            path='/textos'
            element={<Textos />}
          />

          <Route
            path='/imagenes'
            element={<Imagenes />}
          /> */}

          <Route
            path="/test-signalr"
            element={<SignalRTest />}
          />
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App